import { useConfirm } from 'components/Alert/useConfirm';
import { useMutation } from 'query';
import { approve } from 'scenes/FinancePage/IO/data/queryKeyFactory';
import { approveIO } from 'scenes/FinancePage/IO/sources';

export const useApprove = () => {
  const confirm = useConfirm();

  const approveMutation = useMutation(approve(), approveIO, {
    refresh: true,
    successMessage: () => `IO approved`,
    onSuccess: (response: any) => {
      if (response.redirectUrl) {
        window.location.replace(response.redirectUrl);
        return response;
      }
    },
  });

  const { origin } = window.location;

  const handleAction = ({ id, status }: any) => {
    const currentIoUrl = `${origin}/finance/io/${id}/details?ioStatusBeforeDocuSigning=${status?.id}`;

    confirm({
      title: `Approve IO ${id}?`,
      confirmActionLabel: 'Approve',
      inputs: [
        {
          placeholder: 'Comment (optional)',
          type: 'textarea',
          name: 'comment',
        },
      ],
    }).then(({ values: { comment } }: any) => {
      return approveMutation.mutateAsync({
        id,
        comment,
        returnUrl: currentIoUrl,
      });
    });
  };

  return [handleAction, approveMutation];
};
